var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default',[(_vm.$store.state.isLoading)?_c('div',{staticClass:"box is-dark"},[_vm._v(" Estamos registrando seu suporte! ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }